import { useEffect } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { AiSection } from '../components/landing/AiSection';
import { CtaSection } from '../components/landing/CtaSection';
import { Features } from '../components/landing/Features';
import { Hero } from '../components/landing/Hero';
import { HowItWorks } from '../components/landing/HowItWorks';
import { PrivacySection } from '../components/landing/PrivacySection';
import { Showcase } from '../components/landing/Showcase';
import { DestinationMarquee } from '../components/landing/DestinationMarquee';

export function LandingPage() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 28, restDelta: 0.001 });

  useEffect(() => {
    document.title = 'Travessa — планировщик путешествий';
  }, []);

  return (
    <>
      {/* Reading-progress hairline. Cheap, and it makes a long page feel finite. */}
      <motion.div
        style={{ scaleX: progress }}
        className="fixed inset-x-0 top-0 z-[60] h-0.5 origin-left bg-gradient-to-r from-clay-500 via-sun-500 to-lagoon-500"
        aria-hidden
      />
      <Hero />
      <DestinationMarquee />
      <HowItWorks />
      <Features />
      <Showcase />
      <AiSection />
      <PrivacySection />
      <CtaSection />
    </>
  );
}
